import { getSessionId } from '@ab-core-functions/tracking';
import type { LineItemInput, Mutation, MutationUpsertLineItemArgs } from '@ab-core/graphql/dist';
import { CART } from '@ab-core/hooks/cartNew/getCarts/getMyCartQuery';
import { CARTS } from '@ab-core/hooks/cartNew/getCarts/getMyCartsQuery';
import { toast } from '@ab-core/toast';
import type { MutationFunctionOptions } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import type { UpdateCartResponseType } from './updateCart';
import { UPDATE_CART } from './updateCart';

type MutationType = Pick<Mutation, 'upsertLineItem'>;

export type AddLineItemType = {
    success: boolean;
    error: boolean;
    errorMessage?: string;
    pending: boolean;
    response?: UpdateCartResponseType;
    addLineItem: (options?: MutationFunctionOptions) => void;
};
const AddLineItem = (cartId?: string | string[], lineItems?: Array<LineItemInput>): AddLineItemType => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [response, setResponse] = useState(undefined);
    const [pending, setPending] = useState(false);
    const sessionId = getSessionId();
    const [addLineItem, { loading }] = useMutation<MutationType, MutationUpsertLineItemArgs>(UPDATE_CART, {
        skip: !cartId || !lineItems,
        variables: {
            cartIds: cartId,
            lineItemInput: lineItems,
            sessionId
        },
        update: () => {
            setSuccess(false);
            setErrorMessage('');
            setError(false);
        },
        onCompleted: (res) => {
            setResponse(res);
            setSuccess(true);
            setPending(false);
        },
        onError: (err) => {
            const searchText = '{"response":';

            const index = err.message.indexOf(searchText);
            const errorObjectString = err.message.substring(index);
            const errorObject = JSON.parse(errorObjectString);

            const sku = errorObject?.response?.errors?.[0]?.extensions?.itemIdentification?.sku;

            if (sku) {
                toast.error(
                    'Konnte nicht hinzugefügt werden',
                    `Die Aktion konnte nicht ausgeführt werden, da der Artikel ${sku} fehlerhaft ist`
                );
            } else {
                toast.error('Konnte nicht hinzugefügt werden');
            }

            setErrorMessage(err.message);
            setError(true);
            setPending(false);
        },
        refetchQueries: [
            { query: CARTS },
            { query: CART, variables: { cartId: Array.isArray(cartId) ? cartId[0] : cartId } }
        ]
    });
    useEffect(() => {
        if (loading === true) {
            setPending(true);
            setSuccess(false);
            setError(false);
        }
    }, [loading]);

    return {
        addLineItem,
        success,
        error,
        response,
        errorMessage,
        pending
    };
};

export default AddLineItem;
